var AltSkillsets = require("lib/academic/AltSkillsets");
var CurrentUser = require("lib/account/CurrentUser");
var Skillsets = require("lib/academic/Skillsets");

require("writing/questions/skillset_standard_label.scss");

var SkillsetStandardLabel = function(props) {
	var name = Skillsets.getName(props.skillset);
	var standard = CurrentUser.get().prefs.skillset_standard;

	if (standard) {
		var standardName = AltSkillsets.getDynamicFullName(
			standard, props.skillset, props.textVariety);

		if (standardName) {
			name = standardName + " - " + name;
		} else {
			name = "Whooo's Reading Skill Sets - " + name;			
		}
	} else {
		var onEditStandards = function(e) {
			$wr.nope(e)
			window.wrPreferences.openPreferencesModal("account", "SkillsetStandard")
		}
		var standardLink = (
			<span> - <a href="#" onClick={ onEditStandards } >Customize</a></span>
		);	
	}

	return (
		<span className="skillsetStandardLabel">
			{ name }{ standardLink }
		</span>
	)
};

SkillsetStandardLabel.propTypes = StrictPropTypes({
	skillset: PropTypes.string.isRequired,
	textVariety: PropTypes.string.isRequired,
});



module.exports = SkillsetStandardLabel;




// WEBPACK FOOTER //
// ./modules/components/writing/questions/SkillsetStandardLabel.js